import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=bcf6b7e8&"
import script from "./Topup.vue?vue&type=script&lang=js&"
export * from "./Topup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports